import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { Claim } from '@lsq-frontend/remote-services/enterprise/common';
import { ClaimService } from '../../../services/claim/claim.service';
import { UiRouteLinks } from '@lsq-frontend/angular-shared/app-constants';

@Injectable()
export class AdminGuard implements CanActivate {
    constructor(private _claimService: ClaimService, private _router: Router) {}

    public canActivate(): Observable<boolean | UrlTree> {
        return this._claimService.claimStream.pipe(
            first(),
            map(
                (claims) =>
                    !!claims[Claim.SystemManagement] ||
                    this._router.parseUrl(`/${UiRouteLinks.NotFound}`)
            )
        );
    }
}
